module.exports = __webpack_public_path__ + "b598f7e2c542075f731cdc4e161a25b1.svg";